import React, { useState } from "react";
import ThumbUpOffAltOutlinedIcon from "@mui/icons-material/ThumbUpOffAltOutlined";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import CommentIcon from "@mui/icons-material/Comment";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import style from "../PostView/PostView.module.css";
import * as constants from "../../constants";
import { RWebShare } from "react-web-share";
import Link from "next/link";
import Swal from "sweetalert2";
import { Avatar } from "@mui/material";
import SignUpModal from "../../ModalContent/SignUpModal/SignUpModal";
import Linkify from "react-linkify";
const BASE_URL = constants.BASE_URL;

const GroupPostAction = ({ post, isLoggedIn, handleSingleGroupPost }) => {
  const [userGeneralInfo, setUserGeneralInfo] = useState({});
  //Comment State
  const [commentText, setCommentText] = useState("");
  const [show, setShow] = useState(false);

  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };
  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  //Comment Function
  const handleComment = (type, postId) => {
    // e.preventDefault();
    fetch(`${BASE_URL}/post/comment/${type}/${postId}/`, {
      method: "POST",
      headers: {
        Authorization: `Token ${
          typeof window !== "undefined"
            ? localStorage.getItem("auth_token")
            : ""
        }`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ content: commentText, is_active: true }),
    })
      .then((res) => {
        if (res.status === 400) {
          Swal.fire("Please, Write Something...");
        } else if (res.status === 201) {
          handleSingleGroupPost();
          document.getElementById("comment_box").value = "";
        }
      })
      .catch((error) => console.log(error));
  };

  //Like Function
  const handleLike = (type, postId) => {
    fetch(`${BASE_URL}/post/like/${type}/${postId}/`, {
      method: "POST",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((res) => {
        handleSingleGroupPost();
      })
      .catch((error) => console.log(error));
  };

  // Getting user general Info
  React.useEffect(() => {
    fetch(`${BASE_URL}/user/user-general-info/${localStorage.getItem("id")}`, {
      method: "GET",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => setUserGeneralInfo(data[0]));
  }, []);

  return (
    <>
      <div className="inte p-2">
        <div className="like">
          <FavoriteRoundedIcon className="like_color" />
          {post?.likes?.total}
        </div>
        <div className={`${style.more_comment} comment`}>
          <Link
            href={{
              pathname: `/post/${post.id}`,
              query: {
                keyword: `${
                  post.title_of_research_article ? "summary" : "thought"
                }`,
              },
            }}
          >
            {post?.latest_comment?.content ? "More comment" : ""}
          </Link>
        </div>
      </div>
      <div className="d-flex justify-content-between border-bottom p-2">
        {isLoggedIn ? (
          <span
            className={`${style.action_bar}`}
            onClick={() =>
              handleLike(
                post.title_of_research_article ? "summary" : "thought",
                post.id
              )
            }
          >
            {post.likes.is_liked ? (
              <span>
                <ThumbUpOffAltOutlinedIcon /> Appreciate
              </span>
            ) : (
              <span>
                <ThumbUpOffAltOutlinedIcon /> Appreciate
              </span>
            )}
          </span>
        ) : (
          <span
            onClick={() => handleSignUpOpen()}
            className={`${style.action_bar}`}
          >
            {post.likes.is_liked ? (
              <span>
                <ThumbUpOffAltOutlinedIcon /> Appreciate
              </span>
            ) : (
              <span>
                <ThumbUpOffAltOutlinedIcon /> Appreciate
              </span>
            )}
          </span>
        )}

        {isLoggedIn ? (
          <span className={`${style.action_bar}`}>
            <CommentIcon /> Comment
          </span>
        ) : (
          <span
            onClick={() => handleSignUpOpen()}
            className={`${style.action_bar}`}
          >
            <CommentIcon /> Comment
          </span>
        )}

        <RWebShare
          data={{
            text: "Web Share - Research Rider",
            url: `/post/${post.id}/?keyword=${
              post.title_of_research_article ? "summary" : "thought"
            }`,
            title: "Research Rider",
          }}
        >
          <span className={`${style.action_bar}`}>
            <ScreenShareOutlinedIcon /> Share
          </span>
        </RWebShare>
      </div>

      {post?.latest_comment && (
        <div className="users-comments p-2">
          <li>
            <div className="users-comments-avatar">
              {isLoggedIn ? (
                <Link href={`/user/${userGeneralInfo?.user}`}>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      border: 1,
                      borderColor: "grey.500",
                    }}
                    alt={post?.latest_comment.user.first_name}
                    src={post.latest_comment.user.profile_pic}
                  />
                </Link>
              ) : (
                <Avatar
                  onClick={() => handleSignUpOpen()}
                  sx={{
                    width: 40,
                    height: 40,
                    border: 1,
                    borderColor: "grey.500",
                  }}
                  alt={post?.latest_comment.user.first_name}
                  src={post.latest_comment.user.profile_pic}
                />
              )}
            </div>
            <div className="users-com">
              {isLoggedIn ? (
                <Link href={`/user/${userGeneralInfo?.user}`}>
                  {post?.latest_comment.user.first_name}
                </Link>
              ) : (
                <span
                  onClick={() => handleSignUpOpen()}
                  className={`${style.comment_user} user-name`}
                >
                  {post?.latest_comment.user.first_name}
                </span>
              )}

              <Linkify
                className="text-break"
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <a target="blank" href={decoratedHref} key={key}>
                    {decoratedText}
                  </a>
                )}
              >
                <span style={{ fontSize: "14px", wordBreak: "break-all" }}>
                  {post?.latest_comment.content}
                </span>
              </Linkify>
            </div>
          </li>
        </div>
      )}
      {isLoggedIn && (
        <div className="my-com p-2">
          <div className="users-comments-avatar">
            <Avatar
              sx={{
                width: 40,
                height: 40,
                border: 1,
                borderColor: "grey.500",
              }}
              alt={post.group_name}
              src={userGeneralInfo?.profile_pic}
            />
          </div>

          <div className="inp-com">
            <form type="submit">
              <textarea
                id="comment_box"
                className="form-control"
                onClick={() => setShow(true)}
                onBlur={(e) => setCommentText(e.target.value)}
                placeholder="Write a comment"
              />
              {show ? (
                <ul className="inp-buttons">
                  <li
                    id="comment_box"
                    onClick={() =>
                      handleComment(
                        `${
                          post.title_of_research_article ? "summary" : "thought"
                        }`,
                        post.id
                      )
                    }
                  >
                    <SendSharpIcon color="primary" />
                  </li>
                </ul>
              ) : null}
            </form>
          </div>
        </div>
      )}

      <SignUpModal
        open={openSingUp}
        handleClose={handleSignUpClose}
        handleOpen={handleSignUpOpen}
      />
    </>
  );
};

export default GroupPostAction;
